"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Pager["default"];
  }
});
var _Pager = _interopRequireDefault(require("react-bootstrap/lib/Pager"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Pager.js
// module id = 6414
// module chunks = 25